import {CircularProgress} from "@mui/material";

export function FallbackView() {
    return (
      <div className='splash-screen'>
        <CircularProgress color="primary" />
      </div>
    )
  }